import { Injectable, Inject, ElementRef } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import Swal from 'sweetalert2';
import * as $ from 'jquery';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class UtilityService {
	FStartDate: any;
	FEndDate: any;
	Fyear_Is_Current: any = 0;
	Fyear_Locked: any = 0;
	CurrentFYear: any = 0;
	Created_By: any = 0;

	constructor(@Inject(HttpClient) private http: HttpClient) {
		this.http = http;
		this.setPermission();
	}

	setPermission() {
		let Permission = JSON.parse(localStorage.getItem('permission'));
		if (!(Permission && Permission.length > 0)) {
			setTimeout(() => {
				this.setPermission();
			}, 0);
			return false;
		}
		if (Permission.length > 0) {
			this.FStartDate = new Date(Permission[0]['Fyear_FromDate']);
			this.FStartDate.setHours(0, 0, 0, 0);
			this.FEndDate = new Date(Permission[0]['Fyear_ToDate']);
			this.FEndDate.setHours(0, 0, 0, 0);
			this.Fyear_Is_Current = this.f_ChkNum(Permission[0]['Fyear_Is_Current']);
			this.Fyear_Locked = this.f_ChkNum(Permission[0]['Fyear_Locked']);
			this.CurrentFYear = this.f_ChkNum(Permission[0]['CurrentFYear']);
			this.Created_By = this.f_ChkNum(Permission[0]['_id']);
		}
	}

	f_ChkNum(p_value) {
		var Num = Number(p_value);
		if (Num) {
			return Num;
		}
		return 0;
	}

	f_chkString(p_value) {
		var Val = (p_value ? p_value.toString() : "").trim();
		return Val;
	}

	public _tabs = new BehaviorSubject(new Array());
	public currentTabs = this._tabs.asObservable();
	toast = Swal.mixin({
		toast: true,
		position: 'center',
		showConfirmButton: false,
		timer: 1000,
		backdrop: `rgba(30, 30, 37, 0.4)`
	});

	getActiveTab() {
		return this._tabs.getValue().filter(t => t.active)[0];
	}

	redirectToPrevious() {
		return new Promise((resolve, reject) => {
			Swal({
				title: 'Go back?',
				text: "All the changes will be lost!",
				type: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Confirm',
				customClass: 'swal-warning-custom'
			})
				.then(result => resolve(result.value))
				.catch(err => reject(err))
		})
	}

	clearContents() {
		return new Promise((resolve, reject) => {
			Swal({
				title: 'Clear all fields?',
				text: "All the changes will be lost!",
				type: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Confirm',
				customClass: 'swal-warning-custom',
			})
				.then(result => {
					resolve(result.value)
				})
				.catch(err => reject(err))
		});
	}

	closeTabConfirmation() {
		return new Promise((resolve, reject) => {
			Swal({
				title: 'Close tab?',
				text: "All the changes will be lost!",
				type: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Confirm',
				customClass: 'swal-warning-custom',
			})
				.then(result => {
					resolve(result.value)
				})
				.catch(err => reject(err))
		})
	}

	changeTabs(tabs) {
		this._tabs.next(tabs);
	}

	ifTabCanBeOpened(tabs, title) {

		//   console.log(tabs, title);

		const _a = tabs.filter(t => t.title === title);
		return _a.length !== 3;
	}

	toastWarningMsg(msg) {
		this.toast({
			type: 'warning',
			title: msg,
			timer: 2500
		});
	}

	replaceTabView(templateRef: ElementRef, param?) {
		$('.tooltip.show').css('display', 'none');
		const _tab = this._tabs.getValue().filter(t => t.active)[0];
		_tab.dataContext.previousTemplate = _tab.template;
		_tab.template = templateRef;

		if (param) {
			localStorage.removeItem('tabProperty');
			_tab.dataContext.param = param;
			localStorage.setItem('tabProperty', param);
		}
	}

	getPreviousTab() {
		$('.tooltip.show').css('display', 'none');
		const _p = this._tabs.getValue().filter(t => t.active)[0].dataContext.previousTemplate;
		localStorage.removeItem('tabProperty');
		this.replaceTabView(_p);
	}
	
	navigateToNextCellWithSelection(params) {
		var KEY_LEFT = 37;
		var KEY_UP = 38;
		var KEY_RIGHT = 39;
		var KEY_DOWN = 40;
		var previousCell = params.previousCellDef;
		var suggestedNextCell = params.nextCellDef;
		if (params.key == 40) {
			var nextRowIndex: number = previousCell.rowIndex + 1;
			var renderedRowCount = params.previousCellDef.column.gridApi.getModel().getRowCount();
			if (nextRowIndex >= renderedRowCount || nextRowIndex < 0) {
				return null;
			} else {
				params.previousCellDef.column.gridApi.getModel().getRow(nextRowIndex).setSelected(true);
				return {
					rowIndex: nextRowIndex,
					column: previousCell.column,
					floating: previousCell.floating
				};
			}
		} else if (params.key == 38) {
			var nextRowIndex: number = previousCell.rowIndex - 1;
			var renderedRowCount = params.previousCellDef.column.gridApi.getModel().getRowCount();
			if (nextRowIndex >= renderedRowCount || nextRowIndex < 0) {
				return null;
			} else {
				params.previousCellDef.column.gridApi.getModel().getRow(nextRowIndex).setSelected(true);
				return {
					rowIndex: nextRowIndex,
					column: previousCell.column,
					floating: previousCell.floating
				};
			}
		} else {
			return suggestedNextCell;
		}
	};

	navigateToNextCell(params) {
		var KEY_LEFT = 37;
		var KEY_UP = 38;
		var KEY_RIGHT = 39;
		var KEY_DOWN = 40;
		var previousCell = params.previousCellDef;
		var suggestedNextCell = params.nextCellDef;

		if (params.key == 40) {
			var nextRowIndex: number = previousCell.rowIndex + 1;
			var renderedRowCount = params.previousCellDef.column.gridApi.getModel().getRowCount();
			if (nextRowIndex >= renderedRowCount) {
				return null;
			} else {
				return {
					rowIndex: nextRowIndex,
					column: previousCell.column,
					floating: previousCell.floating
				};
			}
		} else if (params.key == 38) {
			var nextRowIndex: number = previousCell.rowIndex - 1;
			var renderedRowCount = params.previousCellDef.column.gridApi.getModel().getRowCount();
			if (nextRowIndex < 0) {
				return null;
			} else {
				return {
					rowIndex: nextRowIndex,
					column: previousCell.column,
					floating: previousCell.floating
				};
			}
		} else {
			return suggestedNextCell;
		}
	};

	navigateToNextCell1(params) {
		var KEY_LEFT = 37;
		var KEY_UP = 38;
		var KEY_RIGHT = 39;
		var KEY_DOWN = 40;
		var previousCell = params.previousCellDef;
		var suggestedNextCell = params.nextCellDef;

		if (params.key == 40) {
			//   console.log("arrow down");
			var nextRowIndex: number = previousCell.rowIndex + 1;
			var renderedRowCount = params.previousCellDef.column.gridApi.getModel().getRowCount();
			if (nextRowIndex >= renderedRowCount || nextRowIndex < 0) {
				return null;
			} else {
				params.previousCellDef.column.gridApi.getModel().getRow(nextRowIndex).setSelected(true);
				return {
					rowIndex: nextRowIndex,
					column: previousCell.column,
					floating: previousCell.floating
				};
			}
		} else if (params.key == 38) {
			var nextRowIndex: number = previousCell.rowIndex - 1;
			var renderedRowCount = params.previousCellDef.column.gridApi.getModel().getRowCount();
			if (nextRowIndex >= renderedRowCount || nextRowIndex < 0) {
				return null;
			} else {
				params.previousCellDef.column.gridApi.getModel().getRow(nextRowIndex).setSelected(true);
				return {
					rowIndex: nextRowIndex,
					column: previousCell.column,
					floating: previousCell.floating
				};
			}
		} else {
			return suggestedNextCell;
		}
	};

	formatDateFn(date) {
		var d = date.split("/");
		let dateFormat = d[2] + "/" + d[1] + "/" + d[0];
		return dateFormat;
		// var d = new Date(date),
		//     day = '' + d.getDate(),
		//     month = '' + (d.getMonth() + 1),
		//     year = d.getFullYear();

		// if (month.length < 2) month = '0' + month;
		// if (day.length < 2) day = '0' + day;

		// return [year, month, day].join('-');
	}

	generateColumns(data: any[]) {
		let columnDefinitions = [];
		data.map(object => {
			Object
				.keys(object)
				.map(key => {
					// console.log("key:", key);
					let mappedColumn = {
						headerName: key,
						field: key,
						width: 140,
						enableCellChangeFlash: true
					}
					columnDefinitions.push(mappedColumn);
				})
		})
		//Remove duplicate columns
		columnDefinitions = columnDefinitions.filter((column, index, self) =>
			index === self.findIndex((colAtIndex) => (
				colAtIndex.field === column.field
			))
		)
		// console.log('columnDefinitions:',columnDefinitions);
		// columnDefinitions[0]['checkboxSelection']=true;
		return columnDefinitions;
	}

	getControlPermissions(data) {
		return this.http.post('/api/toolsconfigurations/permissions', data)
	}

	getControlRights(data) {
		return this.http.post('/api/toolsconfigurations/controlspermissions', data)
	}

	getMandatoryControlRights(data) {
		return this.http.post('/api/toolsconfigurations/mandatorycontrolspermissions', data)
	}

	getUserOtherRights(data) {
		return this.http.post('/api/toolsconfigurations/userotherrightspermissions', data)
	}

	ChangeControlPermission(permissions, id) {
		let ObjectKeys: any = Object.keys(permissions);
		if (ObjectKeys[0] == '0') {
			ObjectKeys.splice(0, 1);
		}
		var ParamType = 'ADD';

		if (Number(id)) {
			ParamType = 'MODIFY';
		}

		ObjectKeys.forEach(element => {
			permissions[element]['IS_DISABLE'] = permissions[element][ParamType];
		});
	}

	IsbetweenFinDate(CurrentDate) {
		if (isNaN(Date.parse(CurrentDate))) {
			return false;
		}
		if ((CurrentDate - this.FStartDate) < 0 || (this.FEndDate - CurrentDate) < 0) {
			return false;
		}
		return true;
	}

	ValidateFinDate(CurrentDate) {
		if (isNaN(Date.parse(CurrentDate))) {
			this.toastWarningMsg(`invalid date`);
			return false;
		}
		if ((CurrentDate - this.FStartDate) < 0 || (this.FEndDate - CurrentDate) < 0) {
			this.toastWarningMsg(`date must be between selected financial year`);
			return false;
		}
		return true;
	}

	IsFinancialYearValid() {
		if (this.Fyear_Locked) {
			return `Year ${this.CurrentFYear} is locked`;
		}
		return '';
	}

	IsAllowCurrentFYear() {
		if (this.Fyear_Is_Current == 0) {
			return `Transaction not allowed in previous year`;
		}
		return '';
	}

	IsCurrentFYear() {
		return this.Fyear_Is_Current == 1;
	}

	getCurrentDate() {
		let DateNow: any = new Date();
		DateNow.setHours(0, 0, 0, 0);
		// DateNow.setFullYear(this.FStartDate.getFullYear());
		// DateNow.setFullYear(this.FEndDate.getFullYear());
		if ((DateNow - this.FStartDate) < 0 || (this.FEndDate - DateNow) < 0) {
			DateNow = this.FEndDate;
		}
		return new Date(DateNow);
	}

	getCurrentDateWithFirstDay() {
		let DateNow: any = new Date();
		DateNow.setHours(0, 0, 0, 0);
		if ((DateNow - this.FStartDate) < 0 || (this.FEndDate - DateNow) < 0) {
			DateNow = this.FEndDate;
		}
		DateNow = new Date(DateNow.getFullYear(), DateNow.getMonth(), 1);
		return new Date(DateNow);
	}

	getCurrentDateOneMonthAgo(ConfigDays = 0) {
		let currentDate = this.getCurrentDate();
		if (ConfigDays == 0) {
			var monthAgo: any = new Date(
				currentDate.getFullYear(),
				currentDate.getMonth() - 1,
				currentDate.getDate()
			);
		} else {
			var monthAgo: any = new Date(
				new Date().getFullYear(),
				new Date().getMonth(),
				new Date().getDate() - ConfigDays
			);
		}
		if ((monthAgo - this.FStartDate) < 0) {
			monthAgo = this.FStartDate;
		}
		return monthAgo;
	}

	getCurrentDateMonthAgoConfigWise(ConfigDays) {
		var monthAgo: any = new Date(
			new Date().getFullYear(),
			new Date().getMonth(),
			new Date().getDate() - ConfigDays
		);
		if ((monthAgo - this.FStartDate) < 0) {
			monthAgo = this.FStartDate;
		}
		return monthAgo;
	}

	GetEmailCountModel(Screen_Type, Transaction_No) {
		return {
			Type: "email",
			Email_Type: Screen_Type,
			Created_By: this.Created_By,
			Transaction_NO: Transaction_No
		}
	}

	GetPrintCountModel(Screen_Type, Transaction_No) {
		return {
			Type: "print",
			Email_Type: Screen_Type,
			Created_By: this.Created_By,
			Transaction_NO: Transaction_No
		}
	}

	GetPickPrintCountModel(Screen_Type, params) {
		return {
			Type: params.Type,
			Email_Type: Screen_Type,
			Created_By: params.Created_By,
			Transaction_NO: params.TranscationNo,
			Filter_By: params.Filter_By
		}
	};

	calculateStrength(password: string): number {
		let hasUpper = /[A-Z]/.test(password);
		let hasNumber = /[0-9]/.test(password);
		let hasSymbol = /[^A-Za-z0-9]/.test(password);
		let isLongEnough = password.length >= 8;
	
		let strength = 0;
		
		if (isLongEnough) strength += 25;
		if (hasUpper) strength += 25;
		if (hasNumber) strength += 25;
		if (hasSymbol) strength += 25;
	
		// Only return 100 if all conditions are met
		return (isLongEnough && hasUpper && hasNumber && hasSymbol) ? 100 : strength;
	}
	
}